import React from 'react';
import ListUserPage from "./page/ListUserPage";
import { useNavigate } from 'react-router-dom';

const ListUser = () => {
    const navigate = useNavigate();

    let redirectHome = () => {
        navigate('/');
    }

    let redirectHistoryPayment = (userId) => {
        navigate('/admin/khach-hang/'+ userId +'/lich-su-thanh-toan.html');
    }

    let redirectLogActivity = (userId) => {
        navigate('/admin/khach-hang/'+ userId +'/lich-su-hoat-dong.html');
    }


    return <ListUserPage
        redirect={ () => redirectHome() }
        redirectHistoryPayment = { (userId) => redirectHistoryPayment(userId) }
        redirectLogActivity = { (userId) => redirectLogActivity(userId) }
    />
}

export default ListUser;